export default [
{ label: 'Project Completion', value: 'project-completion' },
{ label: 'Set Custom Date', value: 'set-custom-date' }];